import { css } from "@linaria/core";

import { container } from "../_slider.style";

import { sliderDraggingCls } from "./hook.drag-slide";
import { units, easings } from "@pm2/compat";

export const SLIDE_DURATION_MS = 350;
export const CAPTION_TRANSITION_DURATION_MS = 225;

export const sliderWrapper = css`
  position: relative;
`;

export const sliderContainer = css`
  position: relative;

  max-height: ${units.px(550)};
  width: 100%;

  overflow: hidden;

  touch-action: pan-y pinch-zoom;

  .${container}[data-audience="Grade1To3"] & {
    border-radius: ${units.px(12)};
  }
`;

export const slider = css`
  position: absolute;
  inset: 0;

  transition: transform ${SLIDE_DURATION_MS}ms ${easings.inOutCubic};

  .${sliderDraggingCls} &,
  &.outOfBounds {
    /** disable slide transition while user is dragging the slider around */
    transition: none;
  }

  &.postDrag {
    transition: transform ${SLIDE_DURATION_MS}ms ${easings.outCubic};
  }
`;

export const imageCaptionWrapper = css`
  position: relative;
  overflow: hidden;
  transition: height ${CAPTION_TRANSITION_DURATION_MS}ms ${easings.outQuad};
`;

export const imageCaptionTransition = css`
  &-enter {
    position: relative;
    z-index: 3;

    opacity: 0;

    &-running {
      &::before {
        content: "";

        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        z-index: 2;

        height: 100%;

        background-color: #fff;
      }
    }

    &-active {
      opacity: 1;
      transition: opacity 150ms linear;
    }
  }

  &-exit {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    z-index: 1;
  }
`;
